// search-synonyms.js — Configuración del sistema de búsqueda mejorado
// Editar este archivo para ajustar sinónimos, correcciones y boosting

window.SearchConfig = {

  // Mapa de sinónimos: al buscar la clave, Shopify también busca los valores.
  // Soporta frases de varias palabras (ej: 'crop top') siempre que coincidan exacto.
  synonyms: {
    // Vestidos
    'vestido':       ['vestidos'],
    'vestidos':      ['vestido'],
    'dress':         ['vestido', 'vestidos'],
    'maxi':          ['maxi vestido', 'vestido maxi'],

    // Tops y blusas
    'blusa':         ['blusas'],
    'blusas':        ['blusa'],
    'top':           ['tops'],
    'tops':          ['top'],
    'camiseta':      ['camisetas', 'playera', 'playeras'],
    'camisetas':     ['camiseta', 'playera', 'playeras'],
    'playera':       ['playeras', 'camiseta'],
    'playeras':      ['playera', 'camiseta'],
    't-shirt':       ['playera', 'camiseta'],
    'tshirt':        ['playera', 'camiseta', 't-shirt'],
    'crop top':      ['crop'],
    'top tubo':      ['tubo'],
    'tubo':          ['top tubo'],
    'halter':        ['top halter', 'cuello halter'],
    'halter neck':   ['halter', 'cuello halter'],
    'cuello halter': ['halter'],
    'tirantes':      ['tirante'],
    'tirante':       ['tirantes'],

    // Faldas
    'falda':         ['faldas'],
    'faldas':        ['falda'],
    'midi':          ['falda midi', 'vestido midi'],

    // Pantalones
    'pantalon':      ['pantalones', 'pantalón'],
    'pantalón':      ['pantalones', 'pantalon'],
    'pantalones':    ['pantalón', 'pantalon'],
    'wide leg':      ['palazzo', 'pantalón palazzo'],
    'vaquero':       ['jeans', 'mezclilla', 'denim'],
    'jogger':        ['pantalón jogger'],

    // Shorts / Bermudas
    'short':         ['shorts', 'bermuda'],
    'shorts':        ['short', 'bermuda'],
    'bermuda':       ['short', 'shorts'],

    // Blazers / Sacos
    'blazer':        ['saco'],
    'saco':          ['blazer'],
    'chaqueta':      ['blazer', 'chamarra', 'saco'],

    // Chamarras / Abrigos
    'chamarra':      ['chamarras', 'jacket', 'cazadora'],
    'chamarras':     ['chamarra', 'jacket'],
    'jacket':        ['chamarra', 'chamarras', 'cazadora'],
    'abrigo':        ['abrigos'],
    'abrigos':       ['abrigo'],
    'gabardina':     ['trench', 'abrigo trench'],
    'trench':        ['gabardina', 'abrigo'],

    // Chalecos
    'chaleco':       ['chalecos'],
    'chalecos':      ['chaleco'],

    // Conjuntos / Sets
    'conjunto':      ['conjuntos', 'set'],
    'conjuntos':     ['conjunto', 'set'],

    // Jumpsuits / Enterizos
    'playsuit':      ['jumpsuit', 'enterizo'],
    'jumpsuit':      ['playsuit', 'enterizo'],
    'enterizo':      ['jumpsuit', 'playsuit'],
    'monos':         ['jumpsuit', 'enterizo', 'playsuit'],
    'mono':          ['jumpsuit', 'enterizo', 'playsuit'],
    'overol':        ['jumpsuit', 'enterizo'],
    'romper':        ['playsuit', 'jumpsuit'],

    // Suéteres / Tejidos
    'suéter':        ['sueteres', 'cardigan', 'jersey'],
    'cardigan':      ['suéter', 'jersey'],
    'jersey':        ['suéter', 'cardigan'],
    'jumper':        ['suéter', 'cardigan'],
    'sudadera':      ['sweatshirt'],

    // Leggings / Bodies
    'leggings':      ['legging'],
    'legging':       ['leggings'],

    // Corsets
    'corset':        ['corsé'],
    'corsé':         ['corset'],

    // Palazzo
    'palazzo':       ['palazo', 'palatzo'],
    'palazo':        ['palazzo'],
    'palatzo':       ['palazzo'],

    // Denim
    'jeans':         ['mezclilla', 'denim'],
    'mezclilla':     ['jeans', 'denim'],
    'denim':         ['jeans', 'mezclilla'],

    // Materiales
    'satin':         ['satén'],
    'satén':         ['satin'],
    'algodon':       ['algodón'],
    'algodón':       ['algodon'],
    'lino':          ['linen'],
    'encaje':        ['lace'],
    'terciopelo':    ['velvet'],
    'piel':          ['cuero', 'charol'],
    'cuero':         ['piel', 'charol'],
    'viscosa':       ['viscose'],
    'oversized':     ['oversize'],
    'oversize':      ['oversized'],

    // Estampados / Prints
    'lunares':       ['puntos', 'polka'],
    'puntos':        ['lunares', 'polka'],
    'polka':         ['lunares', 'puntos'],
    'polka dots':    ['lunares', 'puntos'],
    'polka dot':     ['polka dots', 'lunares'],
    'flores':        ['floral', 'florales'],
    'floral':        ['flores', 'florales'],
    'florales':      ['flores', 'floral'],
    'rayas':         ['stripes'],
    'animal':        ['animal print', 'leopardo'],
    'animal print':  ['animal', 'leopardo', 'zebra'],
    'zebra':         ['animal print', 'leopardo'],
    'leopardo':      ['animal print', 'zebra'],
    'cuadros':       ['tartán', 'check'],

    // Accesorios
    'lentejuela':    ['lentejuelas', 'brillos'],
    'lentejuelas':   ['lentejuela', 'brillos'],
    'brillos':       ['lentejuela', 'lentejuelas'],
    'mesh':          ['tul'],
    'tul':           ['mesh'],

    // Plurales — catálogo usa singulares
    'blazers':       ['blazer', 'saco'],
    'sacos':         ['saco', 'blazer'],
    'camisa':        ['camisas'],
    'camisas':       ['camisa'],
    'body':          ['bodies'],
    'bodies':        ['body'],
    'palazzos':      ['palazzo'],
    'jumpsuits':     ['jumpsuit', 'playsuit', 'enterizo'],
    'enterizos':     ['enterizo', 'jumpsuit', 'playsuit'],
    'playsuits':     ['playsuit', 'jumpsuit', 'enterizo'],
    'suéteres':      ['suéter', 'cardigan', 'jersey'],
    'cardigans':     ['cardigan', 'suéter', 'jersey'],
    'jerseys':       ['jersey', 'suéter', 'cardigan'],
    'sweater':       ['suéter', 'cardigan'],
    'sweaters':      ['suéter', 'cardigan'],
    'corsets':       ['corset', 'corsé'],
    'sudaderas':     ['sudadera'],
    'overoles':      ['overol'],
    'cazadora':      ['cazadoras', 'chamarra', 'jacket'],
    'cazadoras':     ['cazadora', 'chamarra'],
    'biker':         ['bikers'],
    'bikers':        ['biker'],
    'tank':          ['tanks', 'top'],
    'tanks':         ['tank', 'top'],
    'sobrecamisa':   ['sobrecamisas', 'camisa'],
    'sobrecamisas':  ['sobrecamisa', 'camisa'],
    'bermudas':      ['bermuda', 'short', 'shorts'],

    // Olanes (ruffles) — 1,197 productos
    'olanes':        ['olán'],
    'olán':          ['olanes'],

    // Nudo — 734 productos
    'nudo':          ['nudos'],
    'nudos':         ['nudo'],

    // Fluido / flowy — 436 productos
    'fluido':        ['fluida', 'fluidos'],
    'fluida':        ['fluido'],

    // Capa (estilo) — 74 productos
    'capa':          ['capas'],
    'capas':         ['capa'],

    // Cargo — 280 productos
    'cargo':         ['cargo pants', 'pantalón cargo'],
    'cargo pants':   ['cargo', 'pantalón cargo'],

    // Globo / manga globo — 69 productos
    'globo':         ['manga globo', 'mangas globo'],
    'manga globo':   ['globo', 'mangas globo'],
    'mangas globo':  ['manga globo', 'globo'],

    // Básico/a — 246 productos
    'básico':        ['básicos'],
    'básicos':       ['básico'],
    'básica':        ['básicas'],
    'básicas':       ['básica'],

    // Manga larga / corta — 1,845 / 1,103 productos
    'manga larga':   ['mangas largas'],
    'mangas largas': ['manga larga'],
    'manga corta':   ['mangas cortas'],
    'mangas cortas': ['manga corta'],

    // Descriptores de estilo
    'plisado':       ['plisados', 'plisada', 'plisadas'],
    'plisados':      ['plisado'],
    'plisada':       ['plisado', 'plisadas'],
    'asimétrico':    ['asimétrica', 'asimétricos'],
    'asimétrica':    ['asimétrico'],
    'escote':        ['escotes'],
    'escotes':       ['escote'],

    // Traje — sin productos, redirige
    'traje':         ['conjunto', 'blazer'],
    'trajes':        ['traje', 'conjunto'],
    'traje sastre':  ['conjunto', 'blazer', 'saco'],

    // Cinturón — 629 productos
    'cinturón':      ['cinturones'],
    'cinturones':    ['cinturón'],

    // Seda → satén (look similar en fast fashion)
    'seda':          ['satén', 'satin'],

    // Fit holgado
    'holgado':       ['holgada', 'fluido', 'oversize'],
    'holgada':       ['holgado', 'fluido'],

    // Pata de elefante → palazzo
    'pata elefante':     ['palazzo', 'wide leg'],
    'pata de elefante':  ['palazzo', 'wide leg'],

    // Atigrado / animal print
    'atigrado':      ['animal print', 'leopardo', 'cebra'],
    'atigrada':      ['atigrado', 'animal print'],
    'cebra':         ['animal print', 'zebra'],
    'cebrado':       ['cebra', 'zebra'],

    // Little black dress
    'little black dress': ['vestido negro'],
    'lbd':           ['vestido negro'],

    // Hoodies → sudadera
    'hoodies':       ['sudadera', 'sudaderas'],
    'hoodie':        ['sudadera', 'hoodies'],

    // Cuello mao (mandarin collar)
    'cuello mao':    ['mao'],
    'mao':           ['cuello mao'],

    // Colores en frases exactas (multi-palabra — no cubiertas por expansión palabra por palabra)
    'rojo oscuro':   ['tinto', 'vino', 'guinda'],
    'rojo rubi':     ['tinto', 'vino', 'rojo'],
    'rojo tomate':   ['rojo', 'coral'],
    'azul marino':   ['navy', 'marino'],
    'azul cielo':    ['celeste', 'azul'],
    'verde menta':   ['menta', 'pistacho'],
    'verde esmeralda': ['esmeralda', 'jade'],
    'rosa mexicano': ['fucsia', 'magenta'],
  },

  // Correcciones de typos — basado en variaciones reales del CSV de búsquedas.
  typos: {
    // Palazzo
    'palazo':        'palazzo',
    'palazos':       'palazzo',
    'palatzo':       'palazzo',
    'palazzi':       'palazzo',
    'palazz':        'palazzo',
    'palzzo':        'palazzo',
    'palatzzo':      'palazzo',
    'palaxo':        'palazzo',

    // Pantalón
    'pantalon':      'pantalón',
    'pantanlon':     'pantalón',

    // Leggings
    'leggins':       'leggings',
    'legins':        'leggings',
    'leggin':        'leggings',
    'leguins':       'leggings',

    // Jeans
    'jean':          'jeans',
    'jens':          'jeans',

    // Denim
    'demin':         'denim',
    'denis':         'denim',

    // Escote
    'escoto':        'escote',

    // Plisado
    'plisad':        'plisado',
    'plisads':       'plisados',

    // Strapless
    'straplees':     'strapless',
    'straples':      'strapless',
    'straple':       'strapless',
    'strapeles':     'strapless',
    'estrapless':    'strapless',
    'estraples':     'strapless',

    // Vestido
    'vestdo':        'vestido',
    'vestdio':       'vestido',

    // Playera
    'plaera':        'playera',
    'plaeya':        'playera',

    // Algodón
    'algodon':       'algodón',

    // Satin
    'saten':         'satin',
    'satín':         'satin',

    // Túnica
    'tunica':        'túnica',
    'tunicas':       'túnicas',

    // Asimétrico
    'asimetrico':    'asimétrico',
    'asimetrica':    'asimétrica',
    'asimetric':     'asimétrico',

    // Jumpsuit
    'jumsuit':       'jumpsuit',
    'jumpuist':      'jumpsuit',
    'jumpsuite':     'jumpsuit',

    // Lentejuela
    'lentejulea':    'lentejuela',
    'lentejela':     'lentejuela',

    // Blazer
    'blazzer':       'blazer',
    'blaser':        'blazer',

    // Blusa / Falda
    'blusaa':        'blusa',
    'blusass':       'blusas',
    'faldass':       'falda',
    'falas':         'faldas',

    // Chamarra
    'chamerras':     'chamarras',
    'chamarr':       'chamarra',

    // Halter
    'halterofilia':  'halter',
    'haltter':       'halter',
    'healter':       'halter',
    'haltee':        'halter',
    'hañter':        'halter',

    // Conjunto
    'conjuento':     'conjunto',

    // Suéter
    'sueter':        'suéter',
    'sueteres':      'suéteres',
    'sweter':        'suéter',
    'sueters':       'suéteres',
    'suerter':       'suéter',

    // Short
    'shortt':        'short',
    'shortss':       'shorts',

    // Body
    'bodys':         'body',
    'bodie':         'body',

    // Midi
    'mido':          'midi',

    // Wide leg
    'wide ley':      'wide leg',
    'wid leg':       'wide leg',

    // Polka dots
    'polka dota':    'polka dots',
    'polla dota':    'polka dots',
    'polla dots':    'polka dots',
    'polkadots':     'polka dots',
    'polkadot':      'polka dots',
    'polca dots':    'polka dots',
    'polka doy':     'polka dots',
    'polka dora':    'polka dots',

    // Corset
    'corse':         'corset',
    'corsette':      'corset',
    'corsete':       'corset',

    // Jersey
    'jersy':         'jersey',
    'jeysey':        'jersey',
    'jetsey':        'jersey',

    // Peplum
    'perplum':       'peplum',
    'peplu':         'peplum',
    'pleplum':       'peplum',

    // Crop top / Playsuit
    'croptop':       'crop top',
    'play suit':     'playsuit',

    // Gabardina / Trench
    'gabaedina':     'gabardina',
    'trenca':        'trench',

    // Oversized
    'oversised':     'oversized',
    'over size':     'oversized',

    // Anna Sarelly (marca)
    'ana sarelly':   'anna sarelly',
    'anna sarely':   'anna sarelly',
    'anna safely':   'anna sarelly',
    'ana sarely':    'anna sarelly',
    'anna sarrely':  'anna sarelly',
    'ana sarrelly':  'anna sarelly',
    'sarelly':       'anna sarelly',
    'sarely':        'anna sarelly',
    'sarelli':       'anna sarelly',
    'asarelly':      'anna sarelly',
    'sarellu':       'anna sarelly',

    // Básico sin tilde
    'basico':        'básico',
    'basica':        'básica',
    'basicos':       'básicos',
    'basicas':       'básicas',

    // Traje
    'trajr':         'traje',
    'teaje':         'traje',

    // Olán sin tilde
    'olan':          'olanes',

    // Del CSV de búsquedas sin resultados
    'meszclilla':    'mezclilla',
    'vestudo':       'vestido',
    'fiusha':        'fucsia',
    'hoddies':       'hoodies',
    'atrigrado':     'atigrado',
    'sebrado':       'cebra',
    'plizado':       'plisado',
    'pokadog':       'polka dots',
    'polca dita':    'polka dots',
    'jumpis':        'jumpsuit',
    'nregro':        'negro',
    'negrea':        'negra',
    'olgadas':       'holgadas',
    'olgada':        'holgada',
    'trasparentes':  'transparentes',
    'trasparente':   'transparente',
    'jena':          'jeans',
    'psntalon':      'pantalón',
    'cinturon':      'cinturón',
    'cinto':         'cinturón',
    'mndarin':       'mao',
    'mandarin':      'mao',
  },

  // ============================================================
  // Colores — expansión palabra por palabra en queries multi-término.
  // "vestido café" → "vestido café OR vestido chocolate OR vestido camel"
  // Basado en los grupos de color reales del catálogo.
  // Los colores fuera de grupo apuntan al más cercano para dar algún resultado.
  // ============================================================
  colors: {

    // ============================================================
    // GRUPOS REALES DEL CATÁLOGO
    // ============================================================

    // CAFE: café, marrón, camel, kaki, terracota, almendra, arena, chocolate, cobre, latte, rust, sand
    'café':          ['chocolate', 'camel', 'marrón'],
    'marron':        ['café', 'chocolate', 'camel'],
    'marrón':        ['café', 'chocolate', 'camel'],
    'camel':         ['café', 'arena', 'kaki'],
    'kaki':          ['café', 'camel', 'arena'],
    'caqui':         ['kaki', 'café', 'camel'],
    'terracota':     ['café', 'cobre', 'rust'],
    'almendra':      ['café', 'camel', 'arena'],
    'arena':         ['camel', 'café', 'almendra'],
    'chocolate':     ['café', 'marrón', 'camel'],
    'cobre':         ['terracota', 'rust', 'café'],
    'latte':         ['café', 'camel', 'almendra'],
    'rust':          ['terracota', 'cobre', 'café'],
    'sand':          ['arena', 'camel', 'café'],
    'brown':         ['café', 'marrón', 'chocolate'],
    'tostado':       ['café', 'camel', 'almendra'],
    'cacao':         ['chocolate', 'café', 'marrón'],
    'tan':           ['camel', 'arena', 'café'],

    // TINTO: tinto, rojo rubí, rojo tomate
    'tinto':         ['vino', 'guinda', 'borgoña'],
    'vino':          ['tinto', 'guinda', 'borgoña'],
    'guinda':        ['tinto', 'vino', 'borgoña'],
    'borgoña':       ['tinto', 'vino', 'guinda'],
    'burgundy':      ['tinto', 'vino', 'borgoña'],
    'burdeos':       ['tinto', 'borgoña', 'vino'],
    'ciruela':       ['tinto', 'vino', 'morado'],

    // BEIGE: beige, stone
    'beige':         ['stone', 'arena'],
    'stone':         ['beige', 'taupe'],
    'nude':          ['beige', 'stone'],
    'taupe':         ['stone', 'gris', 'beige'],

    // AZUL: azul, aguamarina, navy
    'azul':          ['navy', 'aguamarina'],
    'aguamarina':    ['azul', 'navy', 'turquesa'],
    'navy':          ['azul', 'marino'],
    'blue':          ['azul', 'navy'],
    'marino':        ['navy', 'azul'],
    'celeste':       ['azul', 'aguamarina'],
    'cielo':         ['celeste', 'azul'],
    'turquesa':      ['aguamarina', 'azul'],
    'teal':          ['turquesa', 'aguamarina'],
    'agua':          ['turquesa', 'aguamarina'],
    'turquoise':     ['turquesa', 'aguamarina'],

    // VERDE: verde, esmeralda, jade, lemon, lime, menta, pistacho, sage
    'verde':         ['esmeralda', 'jade', 'menta'],
    'esmeralda':     ['verde', 'jade'],
    'jade':          ['verde', 'esmeralda'],
    'lemon':         ['lime', 'pistacho', 'menta'],
    'lime':          ['lemon', 'pistacho', 'menta'],
    'menta':         ['pistacho', 'lime', 'verde'],
    'pistacho':      ['menta', 'lime', 'sage'],
    'sage':          ['pistacho', 'olivo', 'menta'],
    'green':         ['verde', 'esmeralda'],
    'mint':          ['menta', 'pistacho'],
    'olivo':         ['sage', 'verde', 'militar'],
    'militar':       ['olivo', 'sage', 'verde'],
    'olive':         ['sage', 'olivo', 'verde'],

    // GRIS: gris, etherea, plata, plateado, taupe
    'gris':          ['plateado', 'plata', 'taupe'],
    'etherea':       ['gris', 'plateado', 'plata'],
    'plata':         ['plateado', 'gris', 'silver'],
    'plateado':      ['plata', 'gris', 'silver'],
    'gray':          ['gris', 'taupe', 'plateado'],
    'grey':          ['gris', 'gray', 'taupe'],
    'silver':        ['plata', 'plateado', 'gris'],
    'cenizo':        ['gris', 'plateado'],
    'perla':         ['gris', 'plata', 'blanco'],

    // ROJO: rojo, coral, fresa, rojo oscuro
    'rojo':          ['coral', 'fresa'],
    'coral':         ['rojo', 'fresa', 'salmón'],
    'fresa':         ['rojo', 'coral', 'rosa'],
    'red':           ['rojo', 'coral'],
    'salmón':        ['coral', 'fresa', 'rosa'],
    'salmon':        ['salmón', 'coral'],
    'durazno':       ['salmón', 'coral', 'rosa'],
    'melocotón':     ['durazno', 'salmón', 'coral'],
    'naranja':       ['coral', 'terracota', 'rojo'],
    'orange':        ['naranja', 'coral'],

    // ROSA: rosa, blush, flamingo, fucsia
    'rosa':          ['blush', 'flamingo', 'fucsia'],
    'blush':         ['rosa', 'flamingo'],
    'flamingo':      ['rosa', 'blush', 'coral'],
    'fucsia':        ['rosa', 'magenta', 'flamingo'],
    'pink':          ['rosa', 'blush'],
    'magenta':       ['fucsia', 'rosa'],

    // MORADO: morado, malva, lavanda, lila, magenta, morada, orquídea, violeta
    'morado':        ['violeta', 'lila', 'malva'],
    'morada':        ['morado', 'violeta', 'malva'],
    'malva':         ['morado', 'lila', 'lavanda'],
    'lavanda':       ['lila', 'malva', 'morado'],
    'lila':          ['lavanda', 'malva', 'morado'],
    'orquídea':      ['malva', 'morado', 'lila'],
    'violeta':       ['morado', 'lila', 'malva'],
    'lavender':      ['lavanda', 'lila', 'morado'],
    'purple':        ['morado', 'violeta'],
    'uva':           ['morado', 'violeta', 'malva'],

    // AMARILLO: amarillo, butter, dorado, mostaza
    'amarillo':      ['butter', 'mostaza', 'dorado'],
    'butter':        ['amarillo', 'mostaza', 'dorado'],
    'dorado':        ['amarillo', 'oro', 'butter'],
    'mostaza':       ['amarillo', 'butter', 'ocre'],
    'yellow':        ['amarillo', 'butter', 'mostaza'],
    'gold':          ['dorado', 'amarillo', 'mostaza'],
    'oro':           ['dorado', 'amarillo'],
    'mustard':       ['mostaza', 'amarillo', 'butter'],
    'ocre':          ['mostaza', 'amarillo', 'butter'],
    'mantequilla':   ['butter', 'amarillo'],

    // ============================================================
    // COLORES FUERA DE GRUPO — apuntan al grupo más cercano
    // ============================================================

    // Blanco / White (sin grupo propio en catálogo)
    'blanco':        ['ivory', 'hueso', 'crema'],
    'white':         ['blanco', 'ivory', 'hueso'],
    'ivory':         ['blanco', 'hueso', 'crema'],
    'hueso':         ['blanco', 'ivory', 'crema'],
    'crema':         ['blanco', 'ivory', 'latte'],
    'marfil':        ['blanco', 'ivory', 'crema'],
    'yvori':         ['ivory', 'blanco', 'hueso'],
    'champagne':     ['dorado', 'ivory', 'blanco'],
    'champán':       ['champagne', 'dorado'],

    // Negro / Black (sin grupo propio)
    'negro':         ['black'],
    'black':         ['negro'],

    // Neutros
    'neutro':        ['beige', 'stone', 'gris'],
    'neutros':       ['beige', 'gris', 'stone'],
  },

  // Categorías a priorizar en la página de resultados
  boostCategories: ['Vestido', 'Top', 'Pantalón', 'Falda', 'Blusa', 'Crop', 'Blazer', 'Chaleco'],

  // Prefijos conversacionales que se eliminan del query ("busca X" → "X").
  // ORDEN IMPORTANTE: los más largos primero, la alternación del regex es
  // greedy-first. Incluir variantes con y sin acento: _cleanQuery corre antes
  // que _norm, así que aquí el texto todavía trae acentos.
  queryPrefixes: [
    'quiero ver', 'quiero', 'buscando', 'buscar', 'busca', 'busco',
    'dame', 'muéstrame', 'muestrame',
  ],

  minQueryLength: 2,
  maxHistoryItems: 5,
  maxHistoryTermLen: 60,
  historyKey: 'hs-search-history',
};
